import React from 'react';
import PropTypes from 'prop-types';
import NormalButton from '../../Buttons/NormalButton';

const SubmitButton = ({ label, handleSubmit }) => (
  <div className="xl:w-3/4 w-full px-8 flex flex-col items-center">
    <NormalButton action={handleSubmit} buttonText={label} />
  </div>
);

export default SubmitButton;

SubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
